var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18017_16360)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.4511 5.66318C6.23352 5.44561 5.88076 5.44561 5.66318 5.66318C5.44561 5.88076 5.44561 6.23352 5.66318 6.4511L11.2121 12L5.66318 17.5489C5.44561 17.7665 5.44561 18.1192 5.66318 18.3368C5.88076 18.5544 6.23352 18.5544 6.4511 18.3368L12 12.7879L17.5489 18.3368C17.7665 18.5544 18.1192 18.5544 18.3368 18.3368C18.5544 18.1192 18.5544 17.7665 18.3368 17.5489L12.7879 12L18.3368 6.4511C18.5544 6.23352 18.5544 5.88076 18.3368 5.66318C18.1192 5.44561 17.7665 5.44561 17.5489 5.66318L12 11.2121L6.4511 5.66318Z",
    fill: "#373737"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18017_16360"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.d74388c442379829832cad2e8a6226dc.svg";
export { ForwardRef as ReactComponent };